import React from 'react'
import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
    100% {
        transform: translateX(100%);
    }
`

const StyledSkeleton = styled.div`
    display: block;
    height: ${(props: TSkeletonProps) => props.height}px;
    width: ${(props: TSkeletonProps) => (props.width ? `${props.width}px` : '100%')};
    position: relative;
    overflow: hidden;
    background-color: #efefef;
    border-radius: 4px;

    &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.2) 20%,
            rgba(255, 255, 255, 0.5) 60%,
            rgba(255, 255, 255, 0)
        );
        animation: ${shimmer} 2s infinite forwards;
        content: '';
    }
`

type TSkeletonProps = {
    width?: number
    height: number
}

export default function Skeleton(props: TSkeletonProps) {
    return <StyledSkeleton {...props} />
}
